import {
  faBell,
  faCalendarCheck,
  faFileContract,
  faHandshake,
  faWrench,
  faListCheck,
  faUsers,
  faChartLine,
  faUserTie,
  faWallet,
  faHeadset,
  faFileInvoiceDollar,
  faBoxesStacked,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { LANGUAGE } from "services/general";

// Map the notification module to a FontAwesome icon (mirrors the backend
// module icons). Falls back to the bell for unknown modules.
export const MODULE_ICONS = {
  booking_contracts: faCalendarCheck,
  rent_contracts: faFileContract,
  sell_contracts: faHandshake,
  maintenance: faWrench,
  tasks: faListCheck,
  crm: faUsers,
  investment: faChartLine,
  customers: faUserTie,
  wallet: faWallet,
  support: faHeadset,
  invoices: faFileInvoiceDollar,
  inventory: faBoxesStacked,
  marketplace: faStore,
};

// Notification "type" (severity) → colour tokens for the icon well, status pill
// and unread dot, so users can tell info / success / warning / danger apart.
export const TONE_STYLES = {
  success: { well: "bg-success-bg-soft text-success", dot: "bg-success" },
  warning: { well: "bg-warning-bg-soft text-warning", dot: "bg-warning" },
  danger: { well: "bg-danger-bg-soft text-danger", dot: "bg-danger" },
  info: { well: "bg-info-bg-soft text-info", dot: "bg-info" },
};

export const resolveTone = (tone) =>
  tone && TONE_STYLES[tone] ? tone : "info";

// Stored deep-links look like "/ar/rent-contracts/123". Keep the record path but
// swap the stored language segment for the user's current UI language.
export const normalizeActionUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const path = url.replace(/^\/(ar|en)(?=\/|$)/, "");
  return `/${LANGUAGE}${path.startsWith("/") ? "" : "/"}${path}`;
};

// The backend notification payload varies per notification type — derive a
// best-effort title/message plus the deep-link, icon, and severity tone from
// its `data` blob.
export const deriveNotification = (notification) => {
  const payload = notification?.data;
  const data = payload && typeof payload === "object" ? payload : {};
  return {
    title: data.title || data.title_en || data.subject || notification?.type,
    message:
      data.body ||
      data.content ||
      data.message ||
      data.text ||
      data.description ||
      null,
    typeLabel: data.type_label || null,
    statusText: data.status?.text || null,
    tone: resolveTone(data.status?.tone),
    actionUrl: normalizeActionUrl(data.action_url),
    icon: MODULE_ICONS[data.module] || faBell,
  };
};
